<template>
    <div class="lottery-view">
        <div class="notice"><span>完成以上任务获得抽奖券，即可随机抽取转盘中好礼！100%中奖！</span></div>
        <div class="m-container">
            <lottery :prize_list="prize_list" :ua="ua" :login="login" v-if="ready_lottery"></lottery>

            <div class="m-lucky-list">
                <div class="title t-lucky"></div>
                <div class="list-body">
                    <vue-seamless-scroll :data="player_list" class="seamless-warp" :class-option="classOption">
                        <ul>
                            <li v-for="(item,index) in player_list" :key="'item-' + index">
                                <span>{{ item.uid }}</span>
                                <span>抽中了{{ item.giftName }}</span>
                                <span>{{ item.getDate }}</span>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import lottery from '@/components/lottery.pc.vue';
import vueSeamlessScroll from 'vue-seamless-scroll'
//import vuescroll from 'vuescroll';

export default {
    components: {
        'lottery' : lottery,
        //vuescroll,
        vueSeamlessScroll,
    },       
    data () {
        return {
            ops: {
                rail: {
                    opacity: .6,
                    size : '14px',
                    background : '#e3d2af',
                },
                bar: {
                    size : '16px',
                    background: '#977b63',
                    keepShow : true,
                }
            },
            prize_list : [],
            player_list : [],
            ready_lottery : false,
        }
    },
    computed: {   
        classOption () {
            return {
                step: 0.2, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
            }
        }
    },    
    props : {
        ua : {
            default : ()=>{},
        },
        login : {
            default : 0,
        }
    },
    created (){
        this.getPrizesList();
        this.getLuckList();
    },
    methods :{
        getPrizesList () {
        var _this = this;
        _this.$axios.get(_this.$global.ajax_url_map.drwa_list,{
            params : {
                part : 100,
            }
        })
        .then(res => {
            if(res.data.code == 0){
                this.prize_list = res.data.data;
                _this.ready_lottery = true;
            }
        });
        },
        getLuckList (){
        var _this = this;
        _this.$axios.get(_this.$global.ajax_url_map.lucky_list,{
            params : {
                index : 30,
            }
        })
        .then(res => {
            if(res.data.code == 0){
                this.player_list = res.data.data;
            }
        });      
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-device-width: 1025px){
    .m-container{
        display: flex;
        justify-content: space-between;
    }

    .notice{
        text-align: center;
        color: #5c483c;
    }

    .m-lucky-list{
        margin-top: 30px;
    }

    .t-lucky{
        width: 198px;
        height: 34px;
        margin: 0 auto 20px;
        background-image: url(../images/title-lucky-list.png);
    }

    .list-body{
        width: 437px;
        height: 529px;
        background-image: url(../images/bg-lucky-list.png);
        overflow: hidden;
    }

    .list-body ul{
        /* padding: 20px 0; */
    }    

    .list-body li{
        display: flex;
        justify-content: space-between;
        height: 40px;
        line-height: 38px;
        padding: 0 40px;
        color: #5c483c;
        background-image: url(../images/border-list.png);
        background-position: bottom center;
        background-repeat: no-repeat;
    }
}

@media screen and (max-device-width: 1024px){

    .notice{
        margin: 35px 54px 0;
        text-align: center;
        color: #5c483c;
    }

    .t-lucky{
        width: 237px;
        height: 44px;
        margin: 0 auto 36px;
        background-image: url(../images/m/slogen-lucky.png);
    }

    .list-body{
        width: 655px;
        height: 398px;
        margin: 0 auto;
        background-image: url(../images/m/bg-lucky-list.png);
        overflow: hidden;
    }

    .list-body ul{
        /* padding: 20px 0; */
    } 

    .list-body li{
        display: flex;
        justify-content: space-between;
        height: 60px;
        line-height: 58px;
        padding: 0 60px;
        color: #5c483c;
        background-image: url(../images/border-list.png);
        background-position: bottom center;
        background-repeat: no-repeat;
    }
}
</style>

<style>
    .__bar-is-vertical{
        background-image: url(../images/scroll-top.png),

        url(../images/scroll-body.png)!important;

        background-color: transparent!important;

        background-repeat: no-repeat, repeat-y!important;

        background-position: center top, center top!important;

        border-radius: initial!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/lotteryView.pc.vue